// @flow
import React, { type Node } from 'react';

import { COLORS } from 'Components/utils/color/colors.js';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

type Props = {
  children: Node,
  icon: IconName,
  title: string,
};

export function BookingFormBlockField({ children, icon, title }: Props) {
  return (
    <div className="flex mb-4 w-full">
      <Icon className="mt-1" color={COLORS.BLUE} name={icon} hasRtl width="1.875rem" />
      <div className="flex-1 rtl:pl-6 rtl:md:pl-8">
        <h3 className="reset-heading font-bold leading-one my-2 text-md md:text-xl md:mb-2">
          {title}
        </h3>
        {children}
      </div>
    </div>
  );
}
